import React, { Component } from 'react';
import { Skeleton as OriginSkeleton } from "@tinper/next-ui";

class Skeleton extends Component {
    render() { 
        return <OriginSkeleton
            {...this.props} 			
        />;
    }
}
export default Skeleton;